import { createRouter, createWebHashHistory } from 'vue-router'
const logScreen = () => import('../views/LogScreen.vue');
const orderTables = () => import('../views/OrderTables.vue');
const MenuEntrance = () => import('../views/MenuEntrance.vue');
const addTable = () => import('../views/AddTable.vue');
const addTableHostess = () => import('../views/AddTableHostess.vue');
const menuOrder = () => import('../views/MenuOrder.vue');
const central = () => import('../views/Central.vue');
const reserves = () => import('../views/Reserves.vue');
const addOrders = () => import('../views/AddOrders.vue');
const rewardIdentificator = () => import('../views/QrScanner.vue');
const listOrders = () => import('../views/ListOrders.vue');
const teamManager = () => import('../views/TeamManager.vue');
const ScanTarget = () => import('../views/ScanTarget.vue');

const routes = [
    {
        path: '/',
        name: 'central',
        component: central,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/reserves',
        name: 'reserves',
        component: reserves,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/listOrders',
        name: 'listOrders',
        component: listOrders,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/rewardIdentificator',
        name: 'rewardIdentificator',
        component: rewardIdentificator,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/callCenter',
        name: 'callCenter',
        component: addOrders,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/logScreen',
        name: 'logScreen',
        component: logScreen,
        props: true,
        meta: { transition: 'slide', mode: "default", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/orderTables',
        name: 'orderTables',
        component: orderTables,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: true, requiresCarComprobation: false }
    },
    {
        path: '/scanTarget',
        name: 'scanTarget',
        component: ScanTarget,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false },
        children: [
            {
                path: "giftcard",
                name: "giftcard",
                component: () => import('../components/giftcard.vue'),
                props: true,
                meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false },
            }
        ]
    },
    {
        path: '/teamManager',
        name: 'teamManager',
        component: teamManager,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false },
        children: [
            {
                path: "",
                name: "users",
                component: () => import('../components/userManageList.vue'),
                props: true,
                meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false },
            },
            {
                path: ":userid",
                name: "userForm",
                component: () => import('../components/userManageForm.vue'),
                props: true,
                meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: false },
            }
        ]
    },
    {
        path: '/addTable',
        name: 'addTable',
        component: addTable,
        props: true,
        meta: { transition: 'slide', mode: "default", requiresAuth: true, requiresCarComprobation: false }
    },
    {
        path: '/addTableHostess',
        name: 'addTableHostess',
        component: addTableHostess,
        props: true,
        meta: { transition: 'slide', mode: "default", requiresAuth: false, requiresCarComprobation: false }
    },
    {
        path: '/menuOrder',
        name: 'menuOrder',
        component: menuOrder,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: true, requiresCarComprobation: true }
    },
    {
        path: '/menuEntrance',
        name: 'MenuEntrance',
        component: MenuEntrance,
        props: true,
        meta: { transition: 'scale', mode: "out-in", requiresAuth: false, requiresCarComprobation: true }
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from) => { //userCRM Y userTablesCRM son lo que devuelve el login de numeros del POSI
    if (to.meta.requiresAuth && (!localStorage.userCRM || !localStorage.userTablesCRM)) { //si no existen en un componente que requiere autenticacion de posi no envia a ruta
        //localStorage.setItem("setBlockDir", to.fullPath)
        return {
            path: '/logScreen',
            query: { redirect: to.fullPath },
        }
    }
})

export default router
